import type { Project } from '@/lib/types'
import type { FileSystemTree } from '@webcontainer/api'

export const isFileSystemTreeContainsSupabaseJs = (
  fileSystemTree: FileSystemTree,
) => {
  if (isSupabaseJsInSrcLib(fileSystemTree)) {
    return true
  }
  for (const [name, node] of Object.entries(fileSystemTree)) {
    if ('file' in node && name === 'supabase.js') {
      return true
    }
    if (
      'directory' in node &&
      isFileSystemTreeContainsSupabaseJs(node.directory)
    ) {
      return true
    }
  }
  return false
}

export const isSupabaseJsInSrcLib = (fileSystemTree: FileSystemTree) => {
  return (
    'src' in fileSystemTree &&
    'directory' in fileSystemTree.src &&
    'lib' in fileSystemTree.src.directory &&
    'directory' in fileSystemTree.src.directory.lib &&
    'supabase.js' in fileSystemTree.src.directory.lib.directory
  )
}

export const isFileSystemTreeContainsSupabaseDir = (
  fileSystemTree: FileSystemTree,
) => {
  return 'supabase' in fileSystemTree && 'directory' in fileSystemTree.supabase
}

export const isFileSystemTreeContainsSupabase = (
  fileSystemTree: FileSystemTree,
) => {
  return (
    isFileSystemTreeContainsSupabaseJs(fileSystemTree) ||
    isFileSystemTreeContainsSupabaseDir(fileSystemTree)
  )
}

export const isFileSystemTreeListContainsSupabase = (
  fileSystemTreeList: FileSystemTree[] = [],
) => {
  return fileSystemTreeList.some(
    (fileSystemTree) =>
      fileSystemTree && isFileSystemTreeContainsSupabase(fileSystemTree),
  )
}

export const removeProjectIdFromTableName = (
  tableName: string,
  project: Project,
) => {
  return tableName.replace(`${project._id.toString()}_`, '')
}

export const exportSupabaseToWindow = (fileSystemTree: FileSystemTree) => {
  if (!fileSystemTree) return
  if (
    'src' in fileSystemTree &&
    'directory' in fileSystemTree.src &&
    'lib' in fileSystemTree.src.directory &&
    'directory' in fileSystemTree.src.directory.lib &&
    'supabase.js' in fileSystemTree.src.directory.lib.directory &&
    'file' in fileSystemTree.src.directory.lib.directory['supabase.js']
  ) {
    const script = fileSystemTree.src.directory.lib.directory['supabase.js']
      .file as {
      contents: string
    }
    if (script.contents.includes('window.supabase = supabase')) {
      return
    }
    if (script.contents.includes('const supabase = createClient')) {
      script.contents = `${script.contents}\n\nwindow.supabase = supabase;`
      return
    }
  }

  for (const [name, node] of Object.entries(fileSystemTree)) {
    if ('file' in node && name === 'supabase.js') {
      const script = node.file as {
        contents: string
      }
      if (script.contents.includes('window.supabase = supabase')) {
        return
      }
      if (script.contents.includes('const supabase = createClient')) {
        script.contents = `${script.contents}\n\nwindow.supabase = supabase;`
        return
      }
    }
    if (
      'directory' in node &&
      isFileSystemTreeContainsSupabaseJs(node.directory)
    ) {
      exportSupabaseToWindow(node.directory)
    }
  }
}
